import React from 'react';
import { Icon, Text } from 'components';
import { theme } from 'design';
import { ReadOnlyContainer } from '../../styles';

export const ReadOnlySelectInput = ({ text }: { text: string }) => (
  <ReadOnlyContainer>
    <Text size="small">{text}</Text>
    <Icon icon="Dropdown" fill={theme.color.neutral[500]} />
  </ReadOnlyContainer>
);
